export const EXSBPERIODTYPE_DELETE_RESET = 'EXSBPERIODTYPE_DELETE_RESET'
export const EXSBPERIODTYPE_DELETE_SET_ERROR = 'EXSBPERIODTYPE_DELETE_SET_ERROR'
export const EXSBPERIODTYPE_DELETE_SET_DELETED = 'EXSBPERIODTYPE_DELETE_SET_DELETED'
export const EXSBPERIODTYPE_DELETE_TOGGLE_LOADING = 'EXSBPERIODTYPE_DELETE_TOGGLE_LOADING'
